

module.exports = __webpack_require__.stylable.create(
    "HiddenDropdown1055553047",
    {"classes":{"root":"HiddenDropdown1055553047__root","label":"HiddenDropdown1055553047__label","dropdown":"HiddenDropdown1055553047__dropdown"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "HiddenDropdown1055553047",
    null
);
